import { useEffect } from 'react';
import { useUIStore } from 'core/store/uiStore';
import type { ToastType } from 'types/ui.types';

const iconMap: Record<ToastType, string> = {
  success: 'check_circle',
  error: 'error',
  warning: 'warning',
  info: 'info',
};

const colourMap: Record<ToastType, string> = {
  success: 'bg-green-600',
  error: 'bg-red-600',
  warning: 'bg-yellow-500',
  info: 'bg-blue-600',
};

export default function Toast() {
  const toast = useUIStore((s) => s.toast);
  const hideToast = useUIStore((s) => s.hideToast);

  useEffect(() => {
    if (!toast) return;
    const timer = setTimeout(hideToast, toast.duration);
    return () => clearTimeout(timer);
  }, [toast, hideToast]);

  if (!toast) return null;

  return (
    <div
      role="alert"
      aria-live="assertive"
      className={`fixed bottom-6 right-6 z-50 flex items-center gap-3 rounded-xl px-5 py-4 text-white shadow-lg transition-all duration-300 ${colourMap[toast.type]}`}
    >
      <span className="material-symbols-outlined text-xl">{iconMap[toast.type]}</span>
      <span className="text-sm font-medium">{toast.message}</span>
      <button
        onClick={hideToast}
        aria-label="Dismiss notification"
        className="ml-2 opacity-70 hover:opacity-100 transition-opacity"
      >
        <span className="material-symbols-outlined text-base">close</span>
      </button>
    </div>
  );
}
